import { type ReactNode } from "react";
import { useSiteSettings } from "@/hooks/useSiteSettings";

import {SiteSettingsContext} from "@/hooks/useSiteSettingsContext";

/**
 * Site geneli ayarları tek bir yerden yükler ve tüm bileşenlere dağıtır.
 * Header, Footer, Logo, kayıt/giriş ve bakım modu bu bağlamdan okur.
 */
export function SiteSettingsProvider({ children }: { children: ReactNode }) {
  const value = useSiteSettings();

  // PublicSeo owns page titles; settings must not overwrite a lesson title.

  return <SiteSettingsContext.Provider value={value}>{children}</SiteSettingsContext.Provider>;
}

